<div
  id="menuBarDiv"
  class="container-fluid zero-padding custom-display-styles plpmenuHide"
>
  <div class="tab">
    <button
      *ngFor="let productCategory of categoryData?.childCategories"
      class="tablinks"
      id="defaultOpen"
      [ngClass]="{ 'disable-tab-link': loadInProgress }"
      [disabled]="loadInProgress"
      (mouseover)="
        openProduct(
          $event,
          productCategory?.code,
          productCategory?.name,
          productCategory,
          false
        )
      "
      (click)="
        openProduct(
          $event,
          productCategory?.code,
          productCategory?.name,
          productCategory,
          true
        )
      "
    >
      {{ productCategory?.name }}
    </button>
  </div>

  <div
    class="tabcontent_custom row custom-zero-margin img-wdth"
    *ngIf="!loadInProgress && categoryTypes && childCategories; else loading"
  >
    <div class="col-md-12 display-line">
      <div class="col-md-2">
        <div class="demo-img">
          <h1 class="demo-img-size">
            <a
              class="img-links"
              (click)="fetchMenuCategory(categoryName, true); closeMenu()"
            >
              <span
                *ngIf="
                  categoryTypes &&
                  categoryTypes?.image &&
                  categoryTypes?.image?.url !== null
                "
              >
                <img
                  class="category-img"
                  src="{{ apiurl + categoryTypes?.image?.url }}"
                  alt="category"
                />
              </span>

              <cx-media
                class="category-missing-img category-img"
                *ngIf="!categoryTypes?.image?.url"
                [container]="apiurl + categoryTypes?.image?.url"
              >
              </cx-media>
            </a>
          </h1>
        </div>
        <!-- <div
          class="category-desc"
          [innerHTML]="categoryTypes?.description"
        ></div> -->
      </div>
      <div class="col-md-10 links-section height_100">
        <div class="row custom-margin-zero height_100">
          <ul class="demo-ul row custom-display-contents">
            <div
              class="col-md-3"
              [ngClass]="{
                'no-products-color': menuChildCategories.length === 0
              }"
              *ngFor="let menuChildCategories of childCategories; let i = index"
            >
              <li
                class="demo-li col-md-12"
                *ngFor="let category of menuChildCategories; let i = index"
              >
                <a
                  (click)="closeMenu()"
                  routerLink="{{ category?.url }}"
                  class="plp-menu-link"
                  >{{ category?.name | titlecase }}</a
                >
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #loading>
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
